import dayjs from "dayjs";

const config = {
  rowSelection: false,
  search: false,
  scroll: {
    y: 'calc(100vh - 510px)',
  },
  columns: [
    {
      title: '预约ID',
      dataIndex: 'id',
      width: 190,
      ellipsis: true,
      fixed: 'left',
    },
    {
      title: '商机ID',
      dataIndex: 'trackPlanId',
      render: 'businessIdRender',
      width: 190,
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: 'stateRender',
      width: 120,
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 180,
      ellipsis: true,
      render: (text: string) => text || '-',
    },
    {
      title: '公司',
      dataIndex: 'companyName',
      width: 150,
      ellipsis: true,
      render: (text: string) => text || '-',
    },
    {
      title: '预约量房时间',
      dataIndex: 'appointmentTime',
      itemType: 'dateTime',
      width: 180,
      render: (text: string) => text?dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: '实际量房时间',
      dataIndex: 'actualMeasureTime',
      itemType: 'dateTime',
      width: 180,
      render: (text: string) => text?dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: '量房人员',
      dataIndex: 'userName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '量房报告生成时间',
      dataIndex: 'reportGenerationTime',
      itemType: 'dateTime',
      width: 180,
      render: (text: string) => text?dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: '变更次数',
      dataIndex: 'changeCount',
      width: 120,
      render: (text: string) => text|| '-',
    },
    {
      title: '取消原因',
      dataIndex: 'cancelReasonName',
      width: 180,
      ellipsis: true,
      render: (text: string) => text || '-',
    },
  ],
  footer: false,
}

export default config
